/**
 * Created by matei on 13/11/2019
 */

import LoginPage from './login-page';

export default LoginPage;
